import React from "react";
// ANT DESIGN COMPONENTS
import { Modal, Typography, Divider } from "antd";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { updateOpenModalBankActionsHelp } from "../../../redux/banks/bankSlice";
// INTERFACES
import { RootState } from "../../../app/store";

function BankActionsHelpModal() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const { Title, Paragraph } = Typography;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { openModalBankActionsHelp } = useSelector((state: RootState) => state.bank);

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickCancel = () => {
		dispatch(updateOpenModalBankActionsHelp(false));
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Modal
			open={openModalBankActionsHelp}
			width='50%'
			onOk={onClickCancel}
			onCancel={onClickCancel}
			maskClosable={false}
		>
			<div style={{ padding: 16 }}>
				<Title level={3}>Action Button Types - User Guide</Title>

				<Title level={4}>🟢 TOGGLE</Title>
				<Paragraph>
					The Toggle component displays two buttons:
					<ul>
						<li>A Primary Action Button</li>
						<li>A Toggle Action Button</li>
					</ul>
					Each button sends a different command:
					<ul>
						<li>The Primary Action Button sends the first command (e.g., ON).</li>
						<li>The Toggle Action Button sends the second command (e.g., OFF).</li>
					</ul>
					Both buttons will be automatically disabled if the valid states match the elevator’s current service mode.
					This type of button is ideal when you need to send ON and OFF commands independently, without interfering with
					each other.
				</Paragraph>

				<Divider />

				<Title level={4}>🟡 HOLDBACK</Title>
				<Paragraph>
					The Holdback action displays a single button. On the first click (left mouse button), it executes the first
					action. It then requires the user to hold down the right mouse button. While held, a countdown timer appears.
					When the right button is released, the second action (Toggle Action) is executed. This is ideal for
					short-duration actions where a second command is only sent after a few seconds of holding.
				</Paragraph>

				<Divider />

				<Title level={4}>🟠 TURNBACK</Title>
				<Paragraph>
					The Turnback action shows a button that executes the first action on click. Then, after a configured delay, a
					countdown appears. When it reaches zero, the second action (Toggle Action) is triggered. Ideal for time-based
					sequences where a second command must follow the first after a delay.
				</Paragraph>

				<Divider />

				<Title level={4}>🔵 TOGGLE TIMER</Title>
				<Paragraph>
					The Toggle Timer action shows two separate buttons:
					<ul>
						<li>One for the Primary Action</li>
						<li>One for the Toggle Action</li>
					</ul>
					Each button triggers its respective command and a countdown (configured in seconds). While active, buttons are
					disabled to prevent repeated rapid actions. Ideal for ON/OFF commands that need a cooldown period.
				</Paragraph>

				<Divider />

				<Title level={4}>🟣 SWITCH</Title>
				<Paragraph>
					The Switch action displays two buttons:
					<ul>
						<li>The first sends two consecutive actions: OFF (Action) then ON (Toggle Action), based on delay.</li>
						<li>The second is a Cancel button that sends a single OFF command (Toggle Action).</li>
					</ul>
					This button is ideal for use cases where you need to send an OFF command before sending an ON command to
					ensure the previous state is turned off before activating the appropriate command.
				</Paragraph>
			</div>
		</Modal>
	);
}

export default BankActionsHelpModal;
